/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.TEXT.PAGEHEADING,
    label: "Welcome to the Self-Assessment and Quality Improvement Planning Portal",
    description: [
      "The Self-Assessment and Quality Improvement Planning Portal is a digital service that replaces the previous paper process.",
      "Early childhood educators should complete a Self-Assessment and Quality Improvement Planning Portal for each child in their last year of preschool, to pass on important information to the child’s prospective Kindergarten teacher. This enables children to receive the individual support they need as they move into their new school environment."
    ]
  },
  {
    fieldType: FIELD.TEXT.THREEPOINTS,
    label: "Welcome to the Self-Assessment and Quality Improvement Planning Portal"
  },
  {
    fieldType: FIELD.TEXT.FIELDSETHEADING,
    label: "Accessing the Self-Assessment and Quality Improvement Planning Portal",
    description: [
      "You will need a Department of Education account to access the Self-Assessment and Quality Improvement Planning Portal.",
      "If you are an early childhood educator or teacher, please contact your Centre Director to request access."
    ]
  },
  {
    fieldType: FIELD.AUTH.CARD,
  },
  // {
  //   fieldType: FIELD.FORM.DIVIDER
  // },
  // {
  //   fieldType: FIELD.TEXT.PAGEHEADING,
  //   label: "Need support?",
  //   description: [
  //     "If you’re have trouble logging in, please see our [User Guide](https://education.nsw.gov.au/early-childhood-education/working-in-early-childhood-education/transition-to-school/pilot/)",
  //     "Need more information? Read more about the Self-Assessment and Quality Improvement Planning Portal trial.",
  //     "If your question has not been answered, please contact the Department’s Information and Enquiries service on 1800 619 113 (toll free) or at [information@earlylearningcommission.nsw.gov.au](mailto:information@earlylearningcommission.nsw.gov.au)."
  //   ]
  // }
];
